<template>
  <div style="width:100%">
    <div class="famen_list">
      <div class="famen_item" v-for="(item, index) in valist" :key="item.id">
        <div class="fm_row fm_row1">
          <div class="fm_name">{{ item.name }}</div>
          <div class="fm_xh"></div>
        </div>
        <div class="fm_row fm_row2">
          <div class="port">端口：{{ item.portNo }}</div>
          <div class="task" v-show="item.tasknum > 0">
            <font color="#f00">{{ item.tasknum }}</font>
            {{ $t("first.task_num") }}
          </div>
          <div class="task" v-show="item.tasknum == 0">
            {{ $t("first.notask") }}
          </div>
        </div>
        <div class="fm_row fm_row3">
          <div class="timer">{{ item.timeStr }}</div>
          <div>
            <van-switch class="switch" v-model="item.sw" @change="handleSwitch($event, item, index)" active-value="1" inactive-value="0" active-color="#1989fa" inactive-color="#ccc" size="24" />
          </div>
        </div>
      </div>
    </div>
    <pageToast ref="pageToast" />
  </div>
</template>

<script>
import { Dialog } from "vant";

export default {
  props: {
    setting: {
      type: Function,
      default: argument => { }
    },
    hasDeviceChange: {
      type: Boolean,
      default: false
    },
    refreshing: {
      type: Boolean,
      default: false
    },
    pumpGroupsStatus: {
      type: Array,
      default: () => []
    },
    manureStatusList: {
      type: Array,
      default: () => []
    },
    noClear: {
      type: Boolean,
      default: false
    },
    deviceType: {
      type: Number,
      default: null
    }
  },

  data () {
    return {
      valist: [],
      no: localStorage.getItem("no"),
      isLoading: false
    };
  },

  watch: {
    pumpGroupsStatus (v) {
      this.valveFmRelation(v);
    },

    manureStatusList (v) {
      this.valveManureFmRelation(v);
    },

    hasDeviceChange (v) {
      if (v) {
        const no = localStorage.getItem("no");
        this.no = no;
        this.getValaveList(no);
      }
    },

    refreshing (bl) {
      if (bl) {
        this.onRefresh();
      }
    }
  },

  async created () {
    const no = localStorage.getItem("no");
    this.type = sessionStorage.getItem("deviceType");
    this.no = no;
    await this.getValaveList(no);
  },

  methods: {
    // 查询阀门
    async getValaveList (no) {
      if (this.$isblank(no)) {
        this.$toast(this.$t("export.tis_dev"));
        return false;
      }

      await this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0
      });

      await this.$api.getValaveList({ gatewayNo: no }).then(async res => {
        try {
          if (res.errcode === 0) {
            if (!this.$isblank(res.list)) {
              const list = res.list;
              const nowDate = new Date().getTime();
              list.map((item, i) => {
                let timeStep = "";
                item.tasklist = "";
                item.tasknum = 0;
                item.timeStr = "00:00:00";

                if (this.type != 18) {
                  item.sw = item.switchStt.toString();
                }

                console.log("进来到这里了");

                // 不是 18 的设备才进行计时
                if (item.lastUpdate && item.switchStt == 1 && this.type != 18) {
                  // 将 - 替换成 / 兼容 iphone
                  timeStep =
                    nowDate -
                    new Date(`${item.lastUpdate}`.replace(/-/g, "/")).getTime();

                  timeStep = Math.ceil(timeStep / 1000);
                  // 计算出 时 分 秒
                  item.timeStr = this.$calculationTime(timeStep);

                  console.log("timeStep:", timeStep, item.timeStr);

                  if (this.deviceType !== 17 || this.deviceType !== 18) {
                    item.timer = setInterval(() => {
                      timeStep++;
                      item.timeStr = this.$calculationTime(timeStep);
                    }, 1000);
                  }
                }

                // 获取任务列表
                this.getValvaTaskList(item.id, i);
                this.$refs.pageToast.type = 0;
              });
              this.valist = list;
            } else {
              this.$refs.pageToast.type = 1;
            }
          } else {
            this.$toast(res.errmsg);
            return false;
          }
        } catch (e) {
          console.error("ee:", e);
        }
      });

      this.$toast.clear();
    },

    valveFmRelation (pumpGroups) {
      setTimeout(() => {
        // 如果轮灌组中存在开启的阀门  则设置开关状态及定时时间  不需要执行定时
        // 筛选出 水泵 和 施肥
        const shuibengList = [...this.valist].filter(o => o.name.indexOf("水泵") > -1);
        const shifeiList = [...this.valist].filter(o => o.name.indexOf("施肥") > -1);

        shuibengList.map((item, index) => {
          if (pumpGroups && pumpGroups.length) {
            const target = pumpGroups[index];
            if (target) {
              item.sw =
                target.status == 1 ? "1" : this.deviceType == 17 || this.deviceType == 18 ? "0" : item.sw;
              if (this.deviceType == 17 || this.deviceType == 18) {
                clearInterval(item.timer);
              }

              item.time = target.time || 0;
              item.timeStr = target.time || target.opentime ? this.$calculationTime(Number(target.time || target.opentime)) : "00:00:00";
            }
          }
        });

        this.valist = [...shuibengList, ...shifeiList];

        this.openTimer();
      }, 10);
    },

    valveManureFmRelation (manureStatusList) {
      setTimeout(() => {
        // 筛选出 水泵 和 施肥
        const shuibengList = [...this.valist].filter(o => o.name.indexOf("水泵") > -1);
        const shifeiList = [...this.valist].filter(o => o.name.indexOf("施肥") > -1);

        shifeiList.map((item, index) => {
          if (manureStatusList && manureStatusList.length) {
            const target = manureStatusList[index];
            if (target) {
              clearInterval(item.timer);
              item.sw = target.status == 1 ? "1" : this.deviceType == 17 ? "0" : item.sw;
              item.time = target.time || 0;
              item.timeStr = target.time ? this.$calculationTime(target.time) : "00:00:00";
            }
          }
        });

        this.valist = [...shuibengList, ...shifeiList];
        this.openTimer();

      }, 10);
    },

    openTimer () {
      const nowDate = new Date().getTime();
      this.valist.map((item) => {
        let timeStep;
        // 不是 轮灌组的设备 的设备才进行计时
        item.timer && clearInterval(item.timer);
        item.timer = null;

        console.log("item  item item:", item);

        if (item.lastUpdate && item.sw == 1) {
          // 将 - 替换成 / 兼容 iphone
          if (item.time) {
            timeStep = item.time;
            item.timeStr = this.$calculationTime(timeStep);
          } else {
            timeStep = nowDate - new Date(`${item.lastUpdate}`.replace(/-/g, '/')).getTime();
            timeStep = Math.ceil(Number(timeStep) / 1000);
            item.timeStr = this.$calculationTime(timeStep);
          }

          // 计算出 时 分 秒
          item.timer = setInterval(() => {
            timeStep++;
            item.timeStr = this.$calculationTime(timeStep);
          }, 1000);
        }
      });
    },

    // 读取任务列表
    getValvaTaskList (id, i) {
      this.$api
        .getValvaTaskList({
          valveId: id
        })
        .then(res => {
          if (res.errcode === 0 && res.data && res.data.length) {
            const list = [res.data];
            this.valist[i].tasklist = list;
            this.valist[i].tasknum = list.length;
          } else {
            // this.$toast(res.errmsg);
            this.valist[i].tasknum = 0;
            return false;
          }
        });
    },

    // 阀门开闭
    async handleSwitch (value, item, index) {
      try {
        Dialog.confirm({
          // title: '水泵阀门开关',
          message: `确认${Number(value) === 1 ? "打开" : "关闭"}「${this.valist[index].name
            }」吗？`,
          beforeClose: async (action, done) => {
            if (action === "confirm") {
              let id = item.id;
              //  1 开 0 关
              this.$toast.loading({
                message: this.$t("valva.val_loading"),
                forbidClick: true,
                duration: 0
              });

              if (this.$isblank(id)) {
                this.$toast(this.$t("valva.val_chose"));
                return false;
              }

              if (Number(value) === 1) {
                item.sw = "0";
                // 先不变开关状态  等接口反馈后在改变
                // 打开
                var ch = true;
                var cn = this.$t("valva.val_open");
              } else {
                // 关闭
                item.sw = "1";
                var ch = false;
                var cn = this.$t("valva.val_close");
              }

              const _this = this;

              await this.$api
                .setValaveDetail({
                  gatewayNo: this.no,
                  id,
                  switchStt: ch
                })
                .then(res => {
                  _this.$toast.clear();
                  if (res.errcode === 0) {
                    // 成功
                    _this.$toast.success(
                      `「${_this.valist[index].name}}」` +
                      cn +
                      _this.$t("valva.val_success")
                    );
                    // true 是关闭阀门的时候
                    if (ch) {
                      item.sw = "1";
                      let t = 0;
                      // 清空定时器
                      clearInterval(_this.valist[index].timer);
                      // 重新开启定时器

                      if (this.deviceType !== 17) {
                        _this.valist[index].timer = setInterval(() => {
                          t++;
                          _this.valist[index].timeStr = _this.$calculationTime(
                            t
                          );
                        }, 1000);
                      }
                    } else {
                      item.sw = "0";
                      // 成功后 需要停止掉计时器
                      _this.valist[index].timeStr = "00:00:00";
                      clearInterval(_this.valist[index].timer);
                    }
                  } else {
                    _this.$toast(res.errmsg);
                    return false;
                  }
                })
                .catch(err => {
                  console.error(err);
                });

              setTimeout(done, 1000);
            } else {
              if (Number(value) === 1) {
                item.sw = "0";
                // 先不变开关状态  等接口反馈后在改变
                // 打开
                var ch = true;
                var cn = this.$t("valva.val_open");
              } else {
                // 关闭
                item.sw = "1";
                var ch = false;
                var cn = this.$t("valva.val_close");
              }
              done();
            }
          }
        });
      } catch (err) {
        console.error("err:", err);
      }
    },

    async onRefresh () {
      this.isLoading = true;

      // 刷新的时候关闭所有定时器
      this.valist.map(o => {
        if (o.timer) clearInterval(o.timer);
      });

      await this.getValaveList(this.no);
      this.isLoading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.fm_name {
  font-size: 14px;
}

.port,
.task {
  font-size: 12px;
}

.famen_list {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  // padding: 0 0.3rem;
  justify-content: space-between;

  .famen_item {
    width: 49%;
    height: 2.1rem;
    box-shadow: 0 0 0.1rem rgba(0, 0, 0, 0.05);
    border-radius: 0.1rem;
    background: #ffffff;
    margin-bottom: 0.2rem;
    padding: 0.1rem 0.2rem;
    box-sizing: border-box;

    &:nth-child(2n) {
      margin-right: 0 !important;
    }

    .fm_row {
      display: flex;
      height: 34px;
      line-height: 34px;
    }

    .fm_row1 {
      display: flex;
      justify-content: space-between;

      .fm_xh {
        .icon-wifi,
        .icon-dc {
          margin-right: 8px;
        }

        .icon-wifi {
          color: green;
        }

        .icon-dc {
          color: red;
          font-size: 20px;
          vertical-align: bottom;
        }

        img {
          width: 14px;
          height: 14px;
          vertical-align: baseline;
        }
      }
    }

    .fm_row2 {
      display: flex;
      justify-content: space-between;
    }

    .fm_row3 {
      display: flex;
      justify-content: space-between;
      width: 100%;

      .switch {
        font-size: 20px !important;
        vertical-align: middle;
      }
    }
  }
}
</style>
